import { lazy } from 'react';

export default lazy(() =>
  import(
    /* webpackChunkName: 'purchased_components_list_page' */ './PurchasedComponentsListPage'
  ),
);
